import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const FTLCredentialListIdCell = (data) => {
    return _jsx(_Fragment, { children: data.id }, void 0);
};
export default FTLCredentialListIdCell;
//# sourceMappingURL=FTLCredentialListIdCell.js.map